import { endOfDay } from 'date-fns';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';
import { GroupByMode } from 'shared/types/sorting-mode';
import { formatDateKey } from 'shared/utils/format-date-key';
import { getCustomOrderTillDate } from 'shared/utils/get-custom-order-till-date';

export const useTodayCustomOrderByGrouping = (
  groupBy: GroupByMode | undefined | null,
) => {
  const user = useUser();
  const today = useToday();

  return useMemo(() => {
    const groupMode = groupBy ?? GroupByMode.Deadline;
    // todo: activate when iOS supports the new filter options
    // // Try to get the new custom order from settings (if it exists)
    // const newOrder = user?.settings?.customTaskOrder?.today?.[groupMode];
    //
    // // If we have a new order, we need to format it correctly
    // if (newOrder) {
    //   if (Array.isArray(newOrder)) {
    //     // If we are in 'None' mode, the new order is just an array of IDs
    //     return { [noGroupingId]: newOrder as ID[] };
    //   }
    //   // Otherwise it returns the record of IDs
    //   return newOrder;
    // }

    // Fallback to legacy settings if new settings are empty
    if (groupMode === GroupByMode.None || groupMode === GroupByMode.Deadline) {
      return {
        [formatDateKey(today)]: getCustomOrderTillDate(
          user?.settings?.todoSorting ?? {},
          endOfDay(today),
        ),
      };
    }

    const legacySettings = user?.settings?.todayGroupSorting;
    if (!legacySettings) {
      return {};
    }

    switch (groupMode) {
      case GroupByMode.Goal:
        return legacySettings.goal?.sorting ?? {};
      case GroupByMode.LifeArea:
        return legacySettings.lifeArea?.sorting ?? {};
      case GroupByMode.Priority:
        return legacySettings.priority?.sorting ?? {};
      case GroupByMode.Type:
        return legacySettings.type?.sorting ?? {};
      case GroupByMode.DayPart:
        return legacySettings.dayPart?.sorting ?? {};

      default:
        return {};
    }
  }, [
    groupBy,
    user?.settings?.todayGroupSorting,
    user?.settings?.todoSorting,
    today,
  ]);
};
